import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import HomePage from './page/HomePage';
import './App.css';
import { Header, ScrollToTop, Footer, Tips } from 'components';
import Write from './page/Write';
import Certificate from './page/Certificate';
import News from './page/News';
import NewsDetail from './page/News/detail';
import Business from './page/Business';
import NotFound from './page/NotFound';
import QueueAnim from 'rc-queue-anim';
import Check from './page/Check';

const AppContent = () => {
  // 获取当前访问的域名 (例如: hzsjjc.cn 或 www.hzsjjc.cn)
  const currentHostname = window.location.hostname;

  // 判断是否是旧域名 (包含主域名和带www的子域名情况)
  const isOldDomain =
    currentHostname === 'localhost' || currentHostname === 'www.hzsjjc.cn';

  return (
    <div style={{ position: 'relative' }}>
      <ScrollToTop />
      {/* 域名更换提示：仅在旧域名下显示 */}
      {isOldDomain && <Tips />}
      <Header />
      <QueueAnim type={['bottom', 'top']}>
        <div key='app'>
          <Switch>
            {/* 首页 */}
            <Route exact path='/' component={HomePage} />
            {/* 服务项目 */}
            <Route exact path='/service' component={HomePage} />
            {/* 业务方案 */}
            <Route exact path='/business' component={Business} />
            {/* 标准编制 */}
            <Route exact path='/write' component={Write} />
            {/* 资质证书 */}
            <Route path='/certificate' component={Certificate} />
            {/* 新闻详情 - 使用动态路由参数 */}
            <Route path='/news/:id' component={NewsDetail} />
            {/* 新闻动态 */}
            <Route path='/news' component={News} />
            {/* 报告查询 */}
            <Route exact path='/check' component={Check} />
            {/* 404页面 - 必须放在最后 */}
            <Route component={NotFound} />
          </Switch>
        </div>
        <QueueAnim type={'bottom'} animConfig={[{ opacity: [1, 0] }]}>
          <div key='footer'>
            <Footer />
          </div>
        </QueueAnim>
      </QueueAnim>
    </div>
  );
};

const App = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App;
